import { Alert } from "react-bootstrap"
import LocalizedStrings from 'react-localization';

import { ClientLanguage } from "../Api"

let locStrings = new LocalizedStrings({
    de:
    {
        messageNotExistingJobList:"Stellenliste existiert nicht.",
    },
    en: 
    {
        messageNotExistingJobList:"Job list does not exist.",
    }
});

interface NotExistingJobListViewProps{
    clientLanguage?: ClientLanguage
}

export const NotExistingJobListView = (props: NotExistingJobListViewProps) => {

    setLanguage();

    function setLanguage(): void {
        switch(props.clientLanguage) { 
            case ClientLanguage.German: { 
               locStrings.setLanguage('de');
               break; 
            } 
            case ClientLanguage.English: { 
               locStrings.setLanguage('en'); 
               break; 
            } 
            // Otherwise "props.clientLanguage" is "ClientLanguage.BrowserSetting" and language used is browser setting dependent.
        } 
    }

    return (
        <Alert variant="danger" style={{ margin: "30px" }}> 
            <Alert.Heading>{locStrings.messageNotExistingJobList}</Alert.Heading>
        </Alert>
    )
}